export const SITE_URL = "https://seubolsotranquilo.com";
export const SITE_NAME = "Seu Bolso Tranquilo";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

type SeoInput = {
  path: string;
  title: string;
  description: string;
  image?: string;
  imageAlt?: string;
  noindex?: boolean;
  type?: "website" | "article";
  breadcrumbs?: { name: string; path: string }[];
};

type MetaTag = Record<string, string>;
type LinkTag = Record<string, string>;
type ScriptTag = { type: string; children: string };

export function seo(input: SeoInput): {
  meta: MetaTag[];
  links: LinkTag[];
  scripts: ScriptTag[];
} {
  const url = `${SITE_URL}${input.path}`;
  const image = input.image ?? DEFAULT_OG_IMAGE;
  const imageAlt = input.imageAlt ?? input.title;
  const type = input.type ?? "website";

  const meta: MetaTag[] = [
    { title: input.title, key: "title" },
    { name: "description", content: input.description, key: "description" },
    { property: "og:title", content: input.title, key: "og:title" },
    { property: "og:description", content: input.description, key: "og:description" },
    { property: "og:type", content: type, key: "og:type" },
    { property: "og:url", content: url, key: "og:url" },
    { property: "og:site_name", content: SITE_NAME, key: "og:site_name" },
    { property: "og:locale", content: "pt_BR", key: "og:locale" },
    { property: "og:image", content: image, key: "og:image" },
    { property: "og:image:alt", content: imageAlt, key: "og:image:alt" },
    { property: "og:image:width", content: "1200", key: "og:image:width" },
    { property: "og:image:height", content: "630", key: "og:image:height" },
    { property: "og:image:type", content: "image/jpeg", key: "og:image:type" },
    { name: "twitter:card", content: "summary_large_image", key: "twitter:card" },
    { name: "twitter:title", content: input.title, key: "twitter:title" },
    { name: "twitter:description", content: input.description, key: "twitter:description" },
    { name: "twitter:image", content: image, key: "twitter:image" },
  ];

  if (input.noindex) {
    meta.push({ name: "robots", content: "noindex, follow" });
  } else {
    meta.push({ name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1" });
  }

  const links: LinkTag[] = [{ rel: "canonical", href: url }];

  const scripts: ScriptTag[] = [];
  if (input.breadcrumbs && input.breadcrumbs.length > 0) {
    scripts.push({
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: input.breadcrumbs.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: `${SITE_URL}${b.path}`,
        })),
      }),
    });
  }

  return { meta, links, scripts };
}